import React, { Component } from 'react'
import {
	Divider,
	Alert,
	Spin,
	// Form,
	// Input,
	// Button,
	// Select,
	// Row,
	// Col,
	// InputNumber,
	// PageHeader,
	// Upload,
	// Modal,
	// Icon
} from 'antd'
// import debounce from 'lodash/debounce'
// import MeasureUnitForm from './MeasureUnitForm';
import API from '../../../services/API'
// import { objectToFormData } from '../../../services/Utils'
import InventoryEntryForm from './InventoryEntryForm';

// const Option = Select.Option

const INITIAL_DATA = {
	name: '',
	description: '',
    active: 0,
    created_at: '',
    updated_at: '',
}

class InventoryEntryContainer extends Component {
	constructor(props) {
        super()
        const { id } = props.match.params;
        this.id = id;
    }

    id = null;

	// eslint-disable-next-line react/state-in-constructor
	state = {
		data: INITIAL_DATA,
		loading: false,
        response: null,
        editFormData: {},

		manager: {},
        suburb: {},
		managers: {
            data: [],
        },
        suburbs: {
            data: [],
        },
        zipcodes: {
            data: [],
		},

        isLoaded: false,
	}

	componentDidMount() {
		// this.getAdditionalData()
		this.setState({
			isLoaded: true,
		});
	}

	getAdditionalData = () => {

	}

	save = async (data) => {

		await this.setState({
			loading: true,
			response: null,
		})

		const state = {
			...this.state,
			loading: false,
		}

		try {
			// eslint-disable-next-line no-unused-vars
			const response = await API.post('/api/inventory', {
				products: data,
			})
			state.response = {
				type: 'success',
				message: 'Los cambios se hicieron con exito!',
			}
		} catch (error) {
			state.response = {
				type: 'error',
				message: error.response
					? error.response.data.message
					: 'Se produjo un error de conexión',
			}
		}

		this.setState({
			...state,
		})
	}

	getValuesForm = (values) => {
		// this.save(newFormToSend)
	}

	render() {
		return (
			<>
				<div
					style={{
						backgroundColor: 'white',
						borderRadius: 3,
						padding: '8px 16px 16px',
					}}
				>
					<Spin
						spinning={this.state.loading}
						tip="Espere, por favor..."
					>
						<>
							{this.state.response && (
								<Alert
									message={
										this.state.response.type === 'success'
											? 'Éxito'
											: 'Error'
									}
									description={this.state.response.message}
									type={this.state.response.type}
									showIcon
									closable
									onClose={() => this.setState({ response: null })}
								/>
							)}
							<Divider>Entrada de inventario</Divider>

							{
								this.state.isLoaded ? (
									<InventoryEntryForm
										getValues={this.save}
									/>
								) : (null)
							}

                            {/* {
                                this.state.isLoaded ? (
                                    <MeasureUnitForm
                                        getValues={this.getValuesForm}
                                        fields={this.state.editFormData}
                                        manager={this.state.manager}
                                        suburb={this.state.suburb}
                                    />
                                ) : (null)
                            } */}

						</>
					</Spin>
				</div>
			</>
		)
	}
}

export default InventoryEntryContainer
